// extracted by mini-css-extract-plugin
export default {"OptionContainer":"PurchaseOptionItem_OptionContainer__F-OKk","Image":"PurchaseOptionItem_Image__E2X4o"};